import { HttpErrorResponse } from '@angular/common/http';
import { FraudRuleBaseDTO, FraudRulesProductLinesDTO } from '@modeso/types__dgoods-cart';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { resetCartStateFlags } from '../../app.state.actions';
import { fraudRulesReducers } from './fraud-rules.reducer';

export const fraudRulesAdapter: EntityAdapter<FraudRuleBaseDTO> = createEntityAdapter<FraudRuleBaseDTO>({
    selectId: (rule: FraudRuleBaseDTO) => rule._id,
    sortComparer: (a: FraudRuleBaseDTO, b: FraudRuleBaseDTO) => b._id.localeCompare(a._id),
});

export interface CartState {
    loading: boolean;
    error: HttpErrorResponse | null;
    fraudRules: EntityState<FraudRuleBaseDTO>;
    fraudRulesAvailableProductLines: FraudRulesProductLinesDTO;
    success: boolean;
}

export const initialState: CartState = {
    error: null,
    loading: false,
    fraudRules: fraudRulesAdapter.getInitialState(),
    fraudRulesAvailableProductLines: null,
    success: false,
};

export const cartReducer = createReducer(
    initialState,
    ...fraudRulesReducers,
    on(resetCartStateFlags, (state: CartState) => ({ ...state, success: false, error: null, loading: false })),
);
export const {
    selectIds: selectFraudRuleIds,
    selectEntities: selectFraudRuleEntities,
    selectAll: selectAllFraudRules,
    selectTotal: selectFraudRulesTotal,
} = fraudRulesAdapter.getSelectors();
